import { type LoginResponse, LoginResponseSchema } from '@weft/api-definition';
import type { SandboxEnvironment } from '@weft/types';
import { useQuery, useQueryClient } from 'react-query';
import { getPublicApi } from '../../services/api';
import { storeAccountId, storeToken } from '../../services/user-auth';
import { isSandboxEnvironment } from '../../utils/env-indicator';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useSandboxUser(sandboxEnvironment: SandboxEnvironment, options?: CustomUseQueryOptions<void>) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ['sandboxUser', sandboxEnvironment],
    queryFn: async () => {
      const api = getPublicApi();
      const loginResponse = await api.getSandboxUser({
        environment: sandboxEnvironment,
      });

      const validatedLoginResponse = LoginResponseSchema.parse(loginResponse satisfies LoginResponse);

      storeAccountId(validatedLoginResponse.user.accountId);
      storeToken(validatedLoginResponse.token);

      await queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] !== 'sandboxUser',
      });
    },
    enabled: isSandboxEnvironment(),
    ...options,
  });
}